/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Hero_HeadingInputs */

const ja_playdata_home_hero_heading = /** @type {(inputs: Playdata_Home_Hero_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームイベント- eスポーツ大会視聴データ分析サービス`)
};

const en_playdata_home_hero_heading = /** @type {(inputs: Playdata_Home_Hero_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance Reporting for Japanese Esports and Game Streaming`)
};

/**
* | output |
* | --- |
* | "Performance Reporting for Japanese Esports and Game Streaming" |
*
* @param {Playdata_Home_Hero_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_hero_heading = /** @type {((inputs?: Playdata_Home_Hero_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Hero_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_hero_heading(inputs)
	return en_playdata_home_hero_heading(inputs)
});